export default "__VITE_ASSET__C_QGAcrZ__"